module.exports = __webpack_public_path__ + "img/Balkonmittreppe.7c75ff1e.jpg";